import { connect } from 'react-redux';
import { actions } from '../redux';
import { getCollection } from '../redux/selectors';
import { getCurrentUser } from '../../publicSession/selectors';
import { addNotificationToQueue } from '../../Notifications/redux/actionCreators';
var mapStateToProps = function (state, ownProps) {
    return {
        exampleCollection: ownProps.exampleCollectionId
            ? getCollection(state, ownProps.exampleCollectionId)
            : undefined,
        currentUser: getCurrentUser(state),
    };
};
var mapDispatchToProps = {
    onUndo: actions.undoChanges,
    addNotification: addNotificationToQueue,
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export default connector;
//# sourceMappingURL=CollectNotification.container.js.map